import type { SVGProps } from 'react';
export const IconPointsFivepost = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17014_40713)">
      <path
        d="M18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5Z"
        fill="#58595B"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_17014_40713)">
        <path
          d="M27.6038 22.6642C25.7852 26.2066 22.0903 28.5002 17.998 28.5002C13.9058 28.5002 10.2109 26.2066 8.39228 22.6642C8.03234 21.963 8.37212 21.1082 9.12202 20.8517C9.73196 20.643 10.4086 20.9073 10.7001 21.4782C12.0773 24.1753 14.8863 25.9228 17.998 25.9228C21.1098 25.9228 23.9188 24.1753 25.296 21.4782C25.5875 20.9073 26.2641 20.643 26.8741 20.8517C27.624 21.1082 27.9638 21.963 27.6038 22.6642Z"
          fill="#60BB52"
        />
        <path
          d="M23.1528 17.2096C23.054 15.9105 22.4729 14.8756 21.4726 14.2169C20.6358 13.666 19.5094 13.3866 18.1249 13.3866H17.9696V13.3821H16.6143V11.2699H20.9751C21.6283 11.2699 22.1616 10.7794 22.1616 10.1517C22.1616 9.52358 21.6221 9 20.9751 9H15.4279C14.7726 9 14.2414 9.52685 14.2414 10.1766V14.4868C14.2414 15.1366 14.7726 15.6634 15.4279 15.6634H18.1735C20.0111 15.6634 20.5971 16.4994 20.5971 17.3615C20.5971 18.2102 20.1346 19.5722 18.2056 19.5722C16.6106 19.5722 15.6581 18.5018 15.4617 18.327C14.8719 17.8022 14.2764 17.839 13.8819 18.1845C13.3787 18.6251 13.4404 19.2438 13.7443 19.7013C14.1064 20.2456 15.5173 21.934 18.2056 21.934C19.7327 21.934 21.0814 21.3908 22.003 20.4053C22.8217 19.5297 23.241 18.365 23.1528 17.2096Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_17014_40713">
        <rect
          width={36}
          height={36}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_17014_40713">
        <rect
          width={19.5}
          height={19.5}
          fill="white"
          transform="translate(8.24805 9)"
        />
      </clipPath>
    </defs>
  </svg>
);
